export default {"src":"/_next/static/media/kenya.e212cd3f.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};